import React, { Component, ErrorInfo, ReactNode } from 'react';
import ErrorPage from '../../Pages/Error/ErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorPage
          errorCode={500}
          title="Bir Şeyler Ters Gitti"
          message="Endişelenmeyin, ekibimiz sorunu çözmek için çalışıyor!"
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

